<template>
  <div class="contentBox">
    <div class="pageTitle">
      <h1>数量</h1>
    </div>
    <el-table
      :data="orderData"
      style="width: 100%"
      border
      header-row-class-name="tableHeader"
    >
      <el-table-column
        prop="name"
        label="套餐名称"
        width="140"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="unitPrice"
        label="单价"
        width="117"
        align="center"
      ></el-table-column>
      <el-table-column prop="numbers" label="数量">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.count"
            :min="1"
            :max="99"
            @change="handleChange($event, scope.row)"
            @blur="validScore(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="总计" width="117" align="center">
        <template slot-scope="scope">
          <span :style="{ color: '#306FF6' }" v-if="scope.row.totalPrice"
            >¥{{ scope.row.totalPrice }}</span
          >
        </template>
      </el-table-column>
    </el-table>
    <button class="submitOrder" @click="submitOrder">提交订单</button>
  </div>
</template>
<script>
    import common from '../../../common.vue';

    export default {
        name: "Number",
        data() {
            return {
                orderData: [],
            };
        },
        methods: {
            validScore(row) {
                row.totalPrice = row.unitPrice * row.count;
                console.log(row.total);
            },
            handleChange(value, row) {
                row.totalPrice = row.unitPrice * row.count;
            },
            submitOrder() {
                let _this = this;
                _this.$axios.post(common._BASE_ + '/order/saveOrder',
                    _this.$qs.stringify({count: _this.orderData[0].count, packageId:_this.orderData[0].packageId})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data) {
                        _this.$router.push({
                            path: '/finance/pay',
                            name: 'Pay',
                            params: { oid: r.data }
                        });
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 获取套餐详情
             */
            getPackage(pid) {
                let _this = this;
                _this.orderData = [];
                _this.$axios.post(common._BASE_ + '/rPackage/getPackage',
                    _this.$qs.stringify({pId: pid})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data) {
                        _this.orderData.push({
                            name: r.data.name,
                            unitPrice: r.data.price,
                            count: 1,
                            totalPrice: r.data.price,
                            packageId: r.data.packageId
                        })
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
        },
        mounted(){
              let pid = this.$route.params.pid || this.$route.query.pid;
              if(pid && parseInt(pid) > 0){
                  this.getPackage(pid);
              }
        }
    };
</script>
<style lang="less">
.pageTitle {
  margin-bottom: 20px;
  h1 {
    height: 20px;
    line-height: 24px;
  }
}
.submitOrder {
  width: 110px;
  height: 40px;
  background: #076eff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  margin-top: 12px;
}
.submitOrder:hover {
  background: #4aa3f8;
}
</style>
